import Footer from "../components/Footer";
import SEO from "../components/SEO";

function PrivacyPage() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <SEO
        title="Privacy Policy | KMC Health (Kitmeechai Health)"
        description="Read the KMC Health (Kitmeechai Health) privacy policy to learn how we collect, use, and protect your personal data."
        path="/privacy"
      />
      <div style={{ flex: 1 }}>
        <div className="privacy-page">
          <div className="privacy-header">
            <h1>Privacy Policy</h1>
          </div>

          <div className="privacy-document">
            <iframe
              src="/privacy-policy.pdf"
              title="Privacy Policy"
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PrivacyPage;